module.exports = __webpack_public_path__ + "static/media/bronzeTop2M.25bca5d6.webp";